import { render, staticRenderFns } from "./modalClaimNotes.vue?vue&type=template&id=3329ff37&"
import script from "./modalClaimNotes.vue?vue&type=script&lang=js&"
export * from "./modalClaimNotes.vue?vue&type=script&lang=js&"
import style0 from "./modalClaimNotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports